import Guard from '@/services/middleware'

const DashLayout = () => import('@/layouts/DashLayout')
const Show = () => import('@/views/dash/tickets/Show')
const Home = () => import('@/views/dash/tickets/Home')
const Create = () => import('@/views/dash/tickets/Create')

export default [
    {
        path: '/chamados/',
        component: DashLayout,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkPermission],
        children: [
            {
                path: '',
                name: 'tickets.home',
                component: Home,
                meta: {
                    title: 'Chamados',
                    permission: 2,
                },
            },
            {
                path: 'novo',
                name: 'tickets.create',
                component: Create,
                meta: {
                    title: 'Novo chamado',
                    permission: 2,
                },
            },
            {
                path: ':id',
                name: 'tickets.show',
                component: Show,
                meta: {
                    title: 'Informações detalhadas',
                    permission: 2,
                },
            },
            {
                path: ':id',
                name: 'tickets.transfer',
                component: Show,
                meta: {
                    title: 'Transferir chamado para outro usuário',
                    permission: 2,
                },
            },
        ],
    },
]